'use strict';

import _ from 'lodash';

export default function() {
  return {
    controller: function($scope, $http, $sce, $uibModal) {
      'ngInject';

      $scope.getImage = function (t) {
        var image = /*t.TestimonialCompany.Image ||*/ t.TestimonialCompany.Logo;
        return $sce.trustAsUrl(image);
      }

      function _getTestimonials() {
        $http({
          url: '/api/testimonial/gettestimonials?filter=ResultsFeature&includeCompany=true', method: 'get'
        })
          .then(function Success(result) {
            $scope.testimonials = result.data;
          }, function Fail(result) {
            console.log("Get Testimonials Failed: " + result);
          })
      }

      _getTestimonials();

      if(window.location.hash) {
        setTimeout(function() {
          var id = window.location.hash.replace(/[#!]/g, '');
          var target = $(`#${id}`);
          console.log(target);
          if(target.length) {
            $(window).scrollTop(target.offset().top);
            console.log(id, target.offset().top);
          }
        }, 1000);
      }

      $scope.showLetter = function showLetter(letter) {
        $uibModal.open({
          templateUrl: 'LetterPopupRF',
          size: 'xlg',
          windowClass: 'LargePopup',
          controller: function($scope, $uibModalInstance) {
            $scope.letter = letter;
          }
        });
      };
    },
    template: require('./resultsfeature.html')
  };
};



// WEBPACK FOOTER //
// ./sgcontenteditor/customElements/resultsfeature.js